import { useEffect, useState, useTransition } from "react";

import ImageUpload from "./ImageUpload";
import { AvatarDiv, PictureDiv, PictureParagraph } from "./profileStyles";

const ProfilePicture = props => {
  const [files, setfile] = useState([]);
  const addFile = file => {
    setfile(
      file.map(file =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        }),
      ),
    );
  };
  const imageRemove = () => {
    alert("image remove");
  };
  return (
    <PictureDiv>
      <AvatarDiv position="relative">
        <ImageUpload
          addFile={addFile}
          files={props.thumbnail}
          handleSave={props.handleSave}
          // toggleProfilePicRemoveModal={props.toggleProfilePicRemoveModal}
          handleUserProfileRemove={props.handleUserProfileRemove}
          // isProfilePicRemoveModalOpen={props.isProfilePicRemoveModalOpen}
          updateIsLoading={props.updateIsLoading}
        />
      </AvatarDiv>

      {/* <div>
          <PictureParagraph>
            Choose a photo that helps personalise you
          </PictureParagraph>
        </div> */}
    </PictureDiv>
  );
};
export default ProfilePicture;
